interface osmosisConfigTypes {
    brand: String
    API_URL: String
    TELEMETRY_API_URL?: String
}

const { REACT_APP_ENV } = process.env
let API_URL
let TELEMETRY_API_URL

const selectApi = (env?: string) => {
    if (env === 'DEV') {
        API_URL = 'http://localhost:8080'
    } else if (REACT_APP_ENV === 'TEST') {
        API_URL = 'https://osmosis-os-api-test.azurewebsites.net'
    } else if (REACT_APP_ENV === 'UAT') {
        API_URL = 'https://osmosis-os-api-uat.azurewebsites.net'
    } else if (REACT_APP_ENV === 'PROD') {
        API_URL = 'https://osmosis-os-api.azurewebsites.net'
    } else {
        // Default will be prod api and db
        API_URL = 'https://osmosis-os-api-test.azurewebsites.net'
    }
    return API_URL
}
const selectTelemetryApi = (env?: string) => {
    if (env === 'DEV') {
        // Replace with your local ip
        TELEMETRY_API_URL = 'localhost:8000'
    } else if (env === 'TEST') {
        TELEMETRY_API_URL =
            'https://osmosis-os-current-test-bxhxa3a8cwg0fne8.eastus-01.azurewebsites.net'
    } else if (env === 'PROD') {
        TELEMETRY_API_URL = 'https://osmosis-os-current.azurewebsites.net'
    } else if (env === 'UAT') {
        TELEMETRY_API_URL = 'https://osmosis-os-api-uat.azurewebsites.net'
    } else {
        // Default will be prod api and db
        TELEMETRY_API_URL =
            'https://osmosis-os-current-test-bxhxa3a8cwg0fne8.eastus-01.azurewebsites.net'
    }
    return TELEMETRY_API_URL
}
// eslint-disable-next-line
if (REACT_APP_ENV !== 'PROD') {
    console.info(
        `You're using the ${REACT_APP_ENV} environment with api url: ${selectApi(
            REACT_APP_ENV
        )}`
    )
}

const osmosisConfig: osmosisConfigTypes = {
    brand: 'osmosis',
    API_URL: selectApi(REACT_APP_ENV),
    TELEMETRY_API_URL: selectTelemetryApi(REACT_APP_ENV),
}

export const osmosisFirebaseConfig = {
    apiKey: 'AIzaSyAMvGRtEe4uRYC6C9fDd6cSV-HA-EWzbP0',
    authDomain: 'osmosis-os.firebaseapp.com',
    projectId: 'osmosis-os',
}

export const osmosisGoogleMapApi = 'AIzaSyAERTQkwwnvEkMk5d5GeTco5setwPSpLHo'

export const osmosisGoogleMapAddressApi =
    'AIzaSyCkJMUY2hRSN4EXYY2eHFQE6ENEF4V9b4s'

export default osmosisConfig
